var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "visa"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bg",
    d: "M2.11523 10.1961C2.11523 5.62315 5.82237 1.91602 10.3954 1.91602C14.9683 1.91602 18.6755 5.62315 18.6755 10.1961C18.6755 14.7691 14.9683 18.4763 10.3954 18.4763C5.82237 18.4763 2.11523 14.7691 2.11523 10.1961Z",
    fill: "#172A73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "visa_2",
    d: "M4.22852 6.49609V6.84844L5.51663 7.05124C6.42934 7.19494 7.16494 7.88097 7.37761 8.78681L8.88549 15.2097C8.92281 15.3686 9.06366 15.4809 9.22577 15.4809H11.3418C11.4813 15.4809 11.6076 15.3973 11.6628 15.2681L15.3129 6.74205C15.3627 6.62575 15.2781 6.49609 15.1524 6.49609H13.2028C13.062 6.49609 12.935 6.58115 12.8804 6.71192L10.4353 12.5741L9.45989 7.35742C9.36649 6.8579 8.93346 6.49609 8.429 6.49609H4.22852Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.7f25d77c6fd199e2f7a16b8da121a06a.svg";
export { ForwardRef as ReactComponent };